module.exports = "/lucky-balls/img/combos/84-.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos/84-.png
// module id = 1007
// module chunks = 0